import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Menu } from "@material-ui/icons";
import {
  AppBar,
  Toolbar,
  Box,
  Hidden,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@material-ui/core";
import roles from "constants/roles.constant";
import UserMenu from "./UserMenu";
import { useStyles } from "./headerStyles";
import { SrMainLogo, SrUserBalance } from "../../../common/";

const Header = ({ onToggleSidebar }) => {
  const theme = useTheme();
  const classes = useStyles();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const userRole = useSelector(({ auth }) => auth.role);
  const userAvatar = useSelector(({ auth }) => auth.avatar);

  return (
    <AppBar color="primary" position="fixed" elevation={0}>
      <Box
        className={classes.container}
        display={userRole === roles.OWNER || !matches ? "block" : "flex"}
        justifyContent="flex-end"
      >
        <Toolbar className={classes.toolbar}>
          <Hidden mdUp>
            <IconButton className={classes.menuIcon} onClick={onToggleSidebar}>
              <Menu />
            </IconButton>
            <NavLink to="/portal">
              <SrMainLogo />
            </NavLink>
          </Hidden>
          <Hidden smDown>
            <SrUserBalance />
          </Hidden>
          <UserMenu avatarImage={userAvatar} showUserName={matches} />
        </Toolbar>
      </Box>
    </AppBar>
  );
};

export default Header;
